import { type CSSProperties, useId } from 'react';
import { X } from '@doist/icons/product-ui';
import { Box, Text } from '@doist/marketist';
import cn from 'clsx';
import { ProductUIBoxShadow } from '../product-ui-box-shadow/product-ui-box-shadow';
import { ProductUITaskAttributeButton } from '../product-ui-task-attribute-button/product-ui-task-attribute-button';
import css from './product-ui-modal.module.css';
type ProductUIModalProps = {
  id?: string;
  children: React.ReactNode;
  title: string;
  x?: number | string;
  y?: number | string;
};
export function ProductUIModal({
  children,
  title,
  id,
  x,
  y
}: ProductUIModalProps) {
  const internalId = useId();
  const customProps = {
    '--modal-x': typeof x === 'number' ? `${x}px` : x,
    '--modal-y': typeof y === 'number' ? `${y}px` : y
  } as CSSProperties;
  return <Box id={id ?? internalId} className={cn(css.modal, {
    [css.absolutePositioned]: x || y
  })} style={customProps} data-sentry-element="Box" data-sentry-component="ProductUIModal" data-sentry-source-file="product-ui-modal.tsx">
            <ProductUIBoxShadow data-sentry-element="ProductUIBoxShadow" data-sentry-source-file="product-ui-modal.tsx" />
            <Box className={css.modalHeader} data-sentry-element="Box" data-sentry-source-file="product-ui-modal.tsx">
                <Text size="minor-lg" weight="semibold" data-sentry-element="Text" data-sentry-source-file="product-ui-modal.tsx">
                    {title}
                </Text>
                <ProductUITaskAttributeButton size="lg" data-sentry-element="ProductUITaskAttributeButton" data-sentry-source-file="product-ui-modal.tsx">
                    <X data-sentry-element="X" data-sentry-source-file="product-ui-modal.tsx" />
                </ProductUITaskAttributeButton>
            </Box>
            <Box data-sentry-element="Box" data-sentry-source-file="product-ui-modal.tsx">{children}</Box>
        </Box>;
}